module.exports = __webpack_public_path__ + "img/file-icon.f1adb208.svg";